import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand } from "@/components/ui-bits/Primitives";
import { PROJECTS, IMAGES } from "@/lib/site-data";
import { MapPin } from "lucide-react";

export default function Projects() {
    return (
        <div data-testid="projects-page">
            <PageHero
                kicker="Projects"
                title="Infrastructure that serves real communities."
                lead="From flagship public hubs to healthcare partnerships and municipal P3s — these are the sites we're proud to build and operate."
                image={IMAGES.celina}
            />

            <Section>
                <Container>
                    <div className="space-y-16">
                        {PROJECTS.map((p, i) => (
                            <div key={p.id} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
                                <div className="lg:col-span-7">
                                    <div className="relative overflow-hidden aspect-[16/10]">
                                        <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                                        <div className="absolute inset-0 bg-gradient-to-tr from-ink-900/60 via-transparent to-transparent" />
                                        <div className="absolute top-4 left-4 bg-electric-400 text-ink-900 text-[10px] uppercase tracking-[0.2em] font-semibold px-2.5 py-1">{p.status}</div>
                                    </div>
                                </div>
                                <div className="lg:col-span-5">
                                    <div className="flex items-center gap-2 text-electric-400 text-xs uppercase tracking-[0.2em] mb-4"><MapPin className="w-3.5 h-3.5" /> {p.location}</div>
                                    <h2 className="font-heading text-3xl md:text-4xl text-white tracking-tight leading-tight">{p.title}</h2>
                                    <p className="mt-5 text-slate-400 leading-relaxed">{p.desc}</p>
                                    <div className="mt-8 grid grid-cols-2 gap-5 border-t border-white/10 pt-6">
                                        {p.stats.map((s) => (
                                            <div key={s.v}>
                                                <div className="font-heading text-2xl md:text-3xl text-electric-400">{s.k}</div>
                                                <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-1">{s.v}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Container>
            </Section>

            <CTABand title="Want your community on this map?" subtitle="We're actively developing in Texas — and partnering nationally." />
        </div>
    );
}
